import type { ReactNode } from 'react';
import type { Swiper as SwiperType } from 'swiper/types';
import type Swiper from 'swiper';

export type SlideDescriptor = {
	key: string;
	content: ReactNode;
};

export type VirtualRenderData = {
	offset: number;
	from: number;
	to: number;
};

export const isVirtualEnabled = (virtual: SwiperType['params']['virtual'], isEditableMode: boolean) => {
	if (isEditableMode) return false;
	if (typeof virtual === 'boolean') return virtual;
	return !!virtual?.enabled;
};

export const updateOnVirtualData = (swiper: Swiper | null) => {
	if (!swiper || swiper.destroyed) return;
	const { virtual } = swiper.params;
	const isEnabled = typeof virtual === 'boolean' ? virtual : !!virtual?.enabled;
	if (!isEnabled) return;
	swiper.updateSlides();
	swiper.updateProgress();
	swiper.updateSlidesClasses();
};

export const getVirtualSlidesToRender = (
	slides: SlideDescriptor[],
	virtualData: VirtualRenderData,
	isLoop: boolean
) => {
	const { from, to } = virtualData;
	const getSlideIndex = (index: number) => {
		let slideIndex = index;
		if (index < 0) slideIndex = slides.length + index;
		else if (slideIndex >= slides.length) slideIndex -= slides.length;
		return slideIndex;
	};
	const loopFrom = isLoop ? -slides.length : 0;
	const loopTo = isLoop ? slides.length * 2 : slides.length;
	const result: Array<{ descriptor: SlideDescriptor; virtualIndex: number }> = [];
	for (let i = loopFrom; i < loopTo; i += 1) {
		if (i >= from && i <= to) {
			const descriptor = slides[getSlideIndex(i)];
			if (descriptor) result.push({ descriptor, virtualIndex: i });
		}
	}
	return result;
};
